<template>
  <section class="case-study-sections d-flex flex-column">
    <div
      v-if="!aiReady"
      class="generation-spinner border rounded case-study-sections__section d-flex flex-column"
    >
      <div class="generation-content d-flex align-items-center px-3 py-2">
        <div class="spinner-border spinner-border-sm text-primary mr-3" role="status">
          <span class="sr-only">Generating case study...</span>
        </div>
        <div class="generation-text">
          <small class="text-primary font-weight-bold"
            ><b-icon-stars></b-icon-stars>AI generating content...</small
          >
          <small class="d-block text-muted">Generating sections based on survey data.</small>
        </div>
      </div>
    </div>
    <div
      v-for="(section, idx) in sections"
      :key="idx"
      class="case-study-sections__section d-flex flex-column"
    >
      <TextSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        :isIntroduction="true"
        v-if="section.type == 'introduction' && !showAiReady"
      />
      <TextSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        v-if="section.type == 'text'"
      />
      <TestimonialSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :recipient-id="recipientId"
        :editable="editable"
        :accent-color="accentColor"
        v-if="section.type == 'testimonial'"
      />
      <KeyStatisticsSection
        v-if="section.type == 'key_statistics'"
        :editable="editable"
        :index="idx"
        :section="section"
        :accent-color="accentColor"
        :case-study-id="caseStudyId"
      ></KeyStatisticsSection>
      <ImageSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        v-if="section.type == 'image'"
      />
      <VideoSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        v-if="section.type == 'video'"
      />
      <SurveySnapshotSection
        :section="section"
        :accent-color="accentColor"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        v-if="section.type == 'survey_snapshot'"
      />
    </div>
  </section>
</template>
<script lang="ts">
import TextSection from '@components/case_study_sections/TextSection.vue'
import KeyStatisticsSection from '@components/case_study_sections/KeyStatisticsSection.vue'
import ImageSection from '@components/case_study_sections/ImageSection.vue'
import VideoSection from '@components/case_study_sections/VideoSection.vue'
import TestimonialSection from '@components/case_study_sections/TestimonialSection.vue'
import SurveySnapshotSection from '@components/case_study_sections/SurveySnapshotSection.vue'

export default {
  components: {
    TextSection,
    ImageSection,
    KeyStatisticsSection,
    TestimonialSection,
    VideoSection,
    SurveySnapshotSection,
  },
  props: {
    sections: { type: Array, required: true },
    accentColor: { type: String, required: true },
    caseStudyId: { type: Number, required: true },
    recipientId: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
    aiReady: { type: Boolean, required: false, default: false },
  },
  computed: {
    showAiReady() {
      return !this.aiReady && this.editable
    },
  },
}
</script>

<style lang="sass" scoped>
.case-study-sections
  gap: 18px
  &__section
    gap: 8px
    .title
      font-weight: var(--font-weight-bold)
      font-size: 16px

.generation-spinner
  .generation-content
    min-height: auto
</style>
